import TouchLayout from '@/components/shared/TouchLayout.vue'
import Loading from '@/components/shared/ui/Loading.vue'
import ApiImg from '@/components/shared/ui/ApiImg.vue'
import StaggeredFade from '@/components/shared/ui/StaggeredFade.vue'
import StaggeredSlide from '@/components/shared/ui/StaggeredSlide.vue'
import ModalWindow from '@/components/shared/ui/ModalWindow.vue'
import BaseInput from '@/components/shared/ui/Input.vue'

export default function (app) {
  app.component('TouchLayout', TouchLayout)
  app.component('Loading', Loading)
  app.component('ApiImg', ApiImg)
  app.component('StaggeredFade', StaggeredFade)
  app.component('StaggeredSlide', StaggeredSlide)
  app.component('ModalWindow', ModalWindow)
  app.component('BaseInput', BaseInput)
}
